import { Button, message } from 'antd';
import { useState } from 'react';
import bgImage from './chartBg.png';
import { Question } from '../../../../../store/subCategory';
import { QuestionCreateResponse } from '../../../../../hooks/api/questions';
import {
  AnswerCreateData,
  useQuestionAnswerCreate,
} from '../../../../../hooks/api/answers';
import ModalSurvey, { FormValues } from '../ModalSurvey';
import {
  DefaultFetchError,
  getMessageInError,
} from '../../../../../hooks/fetch';
import SurveySuccess from '../ModalSurvey/SurveySuccess';
import { useAuth } from '../../../../../store/auth';
import useAuthModals from '../../../../Layout/Menu/useAuthModals';

import styles from './index.module.scss';

interface TakeSurveyWorkersProps {
  questions: Question[];
  onSuccess: () => void;
}

function TakeSurveyWorkers({
  questions,
  onSuccess,
}: TakeSurveyWorkersProps) {
  const { user, authorized } = useAuth();
  const { content, openLoginModal } = useAuthModals();
  const [isOpen, setIsOpen] = useState(false);
  const [response, setResponse] = useState<(QuestionCreateResponse | null)[] | null>(null);

  const answerCreate = useQuestionAnswerCreate();

  const onFinish = (values: FormValues) => {
    const ansvers: AnswerCreateData[] = Object.entries(values)
      .filter(([key]) => questions.some((q) => q.id === key))
      .map(([questionId, value]): AnswerCreateData => {
        const answer: AnswerCreateData = {
          questionId,
          tipType: '%',
        };

        if (typeof value.value === 'boolean') answer.valueBoolean = value.value;
        if (typeof value.value === 'string') answer.valueString = value.value;
        if (typeof value.value === 'number') answer.valueNumber = value.value;
        if (Array.isArray(value.value)) answer.valueArray = value.value;
        if (value.tipType) answer.tipType = value.tipType;

        return answer;
      });

    Promise.all(ansvers.map((ansver) => answerCreate.fetch(ansver)))
      .then((resp) => {
        message.success('Successfuly saved!');
        onSuccess();
        setResponse(resp);
      })
      .catch((error: DefaultFetchError) => {
        message.error(getMessageInError(error));
      });
  };

  const handleClick = () => {
    if (!authorized) {
      openLoginModal();

      return;
    }
    if (user?.country?.id !== 233) {
      console.log('user not allowed to take survey since he not from US');

      return;
    }
    setIsOpen(true);
  };

  if (user?.country?.id !== 233) {
    return null;
  }

  return (
    <div className={styles.grayWrapper}>
      {/* eslint-disable-next-line no-nested-ternary */}
      {!isOpen ? (
        <div className={styles.wrapper}>
          <div className={styles.bgImageWrapper}>
            <img
              src={bgImage}
              alt="Take Survey Background"
              className={styles.bgImage}
            />
          </div>
          <div className={styles.blur} />
          <div className={styles.content}>
            <h3 className={styles.title}>
              Service Workers: Not Getting the Tips You Deserve?
            </h3>
            <div className={styles.description}>
              Speak Up! What do you think is a FAIR tip in your industry?
            </div>
            <div className={styles.buttonWrapper}>
              <Button
                type="primary"
                className={styles.button}
                onClick={handleClick}
              >
                Answer Here
              </Button>
              {content}
            </div>
          </div>
        </div>
      ) : (response ? (
        <div className={styles.successWrapper}>
          <SurveySuccess viewResults={() => setIsOpen(false)} />
        </div>
      ) : (
        <ModalSurvey
          isOpen={isOpen}
          questions={questions}
          onFinish={onFinish}
        />
      ))}
    </div>
  );
}

export default TakeSurveyWorkers;
